import { FC } from 'react';
import { RectSkeleton } from 'shared/ui/Skeleton/RectSkeleton';

export const ChessPickerSkeleton: FC = () => {
  return <RectSkeleton maxWidth={440} height={55} />;
};
